import {useEffect, useMemo, useState} from 'react';
import {PAGE_SIZE} from '../constants/edgesConstants';

export const usePagination = (items) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [items]);

  const totalPages = Math.ceil(items.length / PAGE_SIZE);

  const pagedItems = useMemo(() => {
    const safePage = totalPages > 0 ? Math.min(currentPage, totalPages) : 1;
    return items.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);
  }, [items, currentPage, totalPages]);

  const getPageItems = () => {
    if (totalPages <= 7) return Array.from({length: totalPages}, (_, i) => i + 1);
    if (currentPage <= 4) return [1, 2, 3, 4, 5, '...', totalPages];
    if (currentPage >= totalPages - 3)
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  return {currentPage, setCurrentPage, totalPages, pagedItems, getPageItems};
};
